// extracted by mini-css-extract-plugin
export default {"container":"VideoLoader_container__0TKFR","video":"VideoLoader_video__UN5cH"};